var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockFill = function SvgLockFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.5C6 4.673 6.673 4 7.5 4S9 4.673 9 5.5V7H6V5.5ZM11 7h-1V5.5C10 4.121 8.878 3 7.5 3A2.503 2.503 0 0 0 5 5.5V7H4c-.551 0-1 .448-1 1v4c0 .552.449 1 1 1h7c.551 0 1-.448 1-1V8c0-.552-.449-1-1-1Z",
    fill: "#000"
  })));
};
export default SvgLockFill;